var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "promotion-table-pane" },
    [
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _c("el-input", {
            staticClass: "filter-item",
            staticStyle: { width: "200px" },
            attrs: { placeholder: "请输入活动名称", clearable: "" },
            model: {
              value: _vm.listQuery.keywords,
              callback: function ($$v) {
                _vm.$set(_vm.listQuery, "keywords", $$v)
              },
              expression: "listQuery.keywords",
            },
          }),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "primary", icon: "el-icon-search" },
              on: { click: _vm.search },
            },
            [_vm._v("\n      搜索\n    ")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "primary", icon: "el-icon-plus" },
              on: { click: _vm.handleAdd },
            },
            [_vm._v("\n      新增优惠活动\n    ")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          key: _vm.tableKey,
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            stripe: "",
            border: "",
            fit: "",
            "highlight-current-row": "",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              label: "活动ID",
              prop: "fnId",
              align: "center",
              width: "180",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "活动名称",
              prop: "activityName",
              align: "center",
              width: "250",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "场景",
              prop: "orderScene",
              align: "center",
              width: "350",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return _vm._l(scope.row.menuTypeList, function (item) {
                    return _c(
                      "el-tag",
                      {
                        key: item.code,
                        staticStyle: { "margin-right": "1px" },
                      },
                      [
                        _vm._v(
                          "\n          " + _vm._s(item.desc) + "\n        "
                        ),
                      ]
                    )
                  })
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "活动时间", align: "left", width: "250" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [
                      _vm._v(
                        "开始日期：[" +
                          _vm._s(scope.row.startDateFormatter) +
                          "]"
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        "结束日期：[" + _vm._s(scope.row.endDateFormatter) + "]"
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "使用范围", align: "center", width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.markAllGoods
                      ? _c("el-tag", { attrs: { type: "success" } }, [
                          _vm._v("\n          全部商品\n        "),
                        ])
                      : scope.row.targetScope === "goods"
                      ? _c("el-tag", { attrs: { type: "warning" } }, [
                          _vm._v("\n          指定商品\n        "),
                        ])
                      : scope.row.targetScope === "category"
                      ? _c("el-tag", { attrs: { type: "info" } }, [
                          _vm._v("\n          指定分类\n        "),
                        ])
                      : _c("el-tag", { attrs: { type: "info" } }, [
                          _vm._v("\n          未配置\n        "),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "阶梯规则", prop: "tiersRuleList", align: "left" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return _vm._l(scope.row.tiersRuleList, function (item) {
                    return _c(
                      "div",
                      { key: item.sorts || item.sort },
                      [
                        _vm._v("\n          下单金额\n          "),
                        _c("el-link", { attrs: { type: "primary" } }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(item.threshold) +
                              "\n          "
                          ),
                        ]),
                        _vm._v("元\n          立减\n          "),
                        _c("el-link", { attrs: { type: "danger" } }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(item.discount) +
                              "\n          "
                          ),
                        ]),
                        _vm._v("元\n        "),
                      ],
                      1
                    )
                  })
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "有效", width: "80", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-switch", {
                      on: {
                        change: function ($event) {
                          return _vm.handleToggleEnable(scope.row)
                        },
                      },
                      model: {
                        value: scope.row.markForEnable,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "markForEnable", $$v)
                        },
                        expression: "scope.row.markForEnable",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "操作", width: "100", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "mini" },
                        on: {
                          click: function ($event) {
                            return _vm.handleEdit(scope.row)
                          },
                        },
                      },
                      [_vm._v("\n          编辑\n        ")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }